import { Patient } from '@medplum/fhirtypes';
import { usePatientProfileEditor } from '@/components/Timeline/TimelineItems/PatientAccessCall/usePatientProfileEditor';
import { IconDots, IconPencil } from '@tabler/icons-react';
import { ActionIcon, Group, Menu } from '@mantine/core';

interface PatientActionsMenuProps {
  patient: Patient;
  /** Edit name opens the header's PatientNameEditor in place of the name line. */
  onEditName: () => void;
}

export default function PatientActionsMenu({ patient, onEditName }: PatientActionsMenuProps) {
  // Gated like the editor it opens: undefined for a role that cannot update a Patient.
  const saveProfileField = usePatientProfileEditor(patient, false);

  // Edit name is the menu's only item.
  if (!saveProfileField) {
    return null;
  }

  return (
    <Group gap={4} align="center">
      <Menu shadow="md" width={200} position="bottom-end">
        <Menu.Target>
          <ActionIcon variant="subtle" color="gray" size="sm">
            <IconDots size={24} />
          </ActionIcon>
        </Menu.Target>

        <Menu.Dropdown>
          <Menu.Item leftSection={<IconPencil size={18} color="#246A7A" />} onClick={onEditName}>
            Edit name
          </Menu.Item>
        </Menu.Dropdown>
      </Menu>
    </Group>
  );
}
